import React from 'react';
import './InfoBox.scss';
import { THtml } from '../THtml';
import ClassNames from 'classnames';

export enum InfoBoxIcon {
	'warning'='warning-icon',
	'info'='info-icon'
}

interface Props {
	icon: InfoBoxIcon;
	className?: string;
	textkey?: string;
	text?: string;
	visible?: boolean;
}

export const InfoBox: React.FunctionComponent<Props> = (props) => {
	if(!props.text && !props.textkey) 
		return null;

	if(props.visible === false)
		return null;

	const className = ClassNames(
		'InfoBox',
		props.className,
		props.icon
	);

	const getContent = () => {
		if (props.textkey) {
			return <THtml k={props.textkey}  />
		} else if (props.text) {
			return <p>{props.text}</p>
		}
	}

	return (
		<div className={className}>
			{getContent()}
		</div>
	);
};

// Default props
InfoBox.defaultProps = {
	visible: true,
};
